import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

// 액션 타입을 정의해줍니다.
const CHAT_UPDATE = 'chatAction/updateChatState';
const CHAT_INSERT = 'chatAction/insertChatState';

// 액션 생성 함수를 만듭니다.
export const chatUpdate = createAction(CHAT_UPDATE);
export const chatInsert = createAction(CHAT_INSERT);

// 모듈의 초기 상태를 정의합니다.
const initialState = {
  chatList : []
};


// immer 를 사용하여 값을 수정하는 리듀서입니다.
export default handleActions({
  [CHAT_UPDATE]: (state, action) => {
    return produce(state, draft => {
      draft.chatList = action.payload.chatList;
    });
  },
  [CHAT_INSERT]: (state, action) => {
    return produce(state, draft => {
      draft.chatList = draft.chatList.concat(action.payload.chatList);
    });
  },
}, initialState);